"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaResponse = exports.BinaryResponse = exports.Response = void 0;
const metadata_1 = require("./metadata");
class Response extends metadata_1.Metadata {
    constructor(objectInitializer) {
        super();
        this.apply(objectInitializer);
    }
}
exports.Response = Response;
class BinaryResponse extends Response {
    constructor(objectInitializer) {
        super();
        this.binary = true;
        this.apply(objectInitializer);
    }
}
exports.BinaryResponse = BinaryResponse;
class SchemaResponse extends Response {
    constructor(schema, objectInitializer) {
        super();
        this.schema = schema;
        this.apply(objectInitializer);
    }
}
exports.SchemaResponse = SchemaResponse;
//# sourceMappingURL=response.js.map